<template>
  <b-card title="Импорт полосок из SIQ">
    <b-form @submit.prevent="onSubmit">
      <b-form-group label="SIQ-файл">
        <b-form-file
          v-model="form.siq"
          accept=".siq,.zip"
          placeholder="Выберите .siq файл"
          browse-text="Обзор"
        />
        <small class="text-muted">Каждая тема (любого раунда) станет отдельной полоской.</small>
      </b-form-group>

      <b-form-group label="Автор (по умолчанию)">
        <v-select
          v-model="form.author_name"
          :options="authorsOptions"
          :reduce="opt => opt.value"
          label="label"
          :placeholder="isLoadingAuthors ? 'Загрузка…' : 'Выберите автора'"
          taggable
          :disabled="isLoadingAuthors"
        />
      </b-form-group>

      <b-progress v-if="uploadProgress > 0 && uploadProgress < 100" :value="uploadProgress" :max="100" class="mb-1" />

      <b-button type="submit" variant="primary" :disabled="isUploading || !form.siq">
        <b-spinner v-if="isUploading" small /> Импортировать
      </b-button>
    </b-form>

    <div v-if="createdStrips.length" class="mt-2">
      <h5>Создано полосок: {{ createdStrips.length }}</h5>
      <b-list-group>
        <b-list-group-item v-for="strip in createdStrips" :key="strip.id" class="d-flex justify-content-between align-items-center">
          <span>{{ strip.name }}</span>
          <div>
            <b-button size="sm" variant="outline-primary" :to="{ name: 'strip-edit', params: { id: strip.id } }">
              Редактировать
            </b-button>
            <b-button size="sm" variant="outline-secondary" :to="{ name: 'strip-builder', params: { id: strip.id } }">
              В построителе
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BForm, BFormGroup, BFormFile, BButton, BSpinner, BProgress, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, onUnmounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import stripBuilderStoreModule from '../builder/stripBuilderStoreModule'

export default {
  components: {
    BCard, BForm, BFormGroup, BFormFile, BButton, BSpinner, BProgress, BListGroup, BListGroupItem,
    vSelect,
  },
  setup() {
    const STORE_MODULE_NAME = 'strip-builder'
    const toast = useToast()

    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, stripBuilderStoreModule)
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const form = ref({
      siq: null,
      author_name: null,
    })
    const isUploading = ref(false)
    const uploadProgress = ref(0)
    const createdStrips = ref([])
    const authorsOptions = ref([])
    const isLoadingAuthors = ref(false)

    isLoadingAuthors.value = true
    store.dispatch('strip-builder/fetchAuthors')
      .then(response => {
        authorsOptions.value = (response.data || []).map(a => ({
          label: a.name,
          value: a.name,
        }))
      })
      .catch(() => {})
      .finally(() => { isLoadingAuthors.value = false })

    const showToast = (title, variant) => {
      toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertTriangleIcon',
          variant,
        },
      })
    }

    const onSubmit = () => {
      isUploading.value = true
      uploadProgress.value = 0
      const formData = new FormData()
      formData.append('siq', form.value.siq)
      if (form.value.author_name) formData.append('author_name', form.value.author_name)

      store.dispatch('strip-builder/importSiq', {
        formData,
        onUploadProgress: e => {
          if (e.total) uploadProgress.value = Math.round((e.loaded * 100) / e.total)
        },
      })
        .then(response => {
          isUploading.value = false
          createdStrips.value = response.data || []
          showToast(`Импортировано ${createdStrips.value.length} полосок`, 'success')
        })
        .catch(error => {
          isUploading.value = false
          uploadProgress.value = 0
          const msg = error.response?.data?.message || 'Ошибка импорта SIQ'
          showToast(msg, 'danger')
        })
    }

    return {
      form, isUploading, uploadProgress, createdStrips, authorsOptions, isLoadingAuthors, onSubmit,
    }
  },
}
</script>
